import { useState } from "react";
import { Badge, Collapse, Offcanvas, Table } from "react-bootstrap";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FieldErrorNotification = ({
  Show,
  Hide,
  Title,
  dataEntryQueryNotification,
  tableRef,
  onMouseDown,
  generateQueryNotificationStatusStudySubjectFormField
}) => {
  const [openChatModule, setOpenChatModule] = useState("");
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {dataEntryQueryNotification?.length === 0 ? 
            <NoDataFoundTable MSG={"Field Notification error not found!"}/>
          :
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th onMouseDown={(e) => onMouseDown(e, 0)} style={{ width: 45 }} className="text-center">Sr.</th>
                  <th>Field Name</th>
                  <th>Field Value</th>
                  <th>NotifyId</th>
                  <th>Status</th>
                  <th>Generated By</th>
                </tr>
              </thead>
              <tbody>
                {dataEntryQueryNotification?.map((item, index) => (
                  <>
                    <tr onClick={() => setOpenChatModule(openChatModule === item?.queryId ? "" : item?.queryId)} key={index} className="CP">
                      <td className="text-center">{index + 1}.</td>
                      <td title={item?.fieldLabel}>{item?.fieldName}</td>
                      <td>{item?.fieldValue}</td>
                      <td>{item?.queryId}</td>
                      <td className={`text-capitalize fw-bold ${item?.status === "close" ? "text-success" : "text-danger"}`}>{item?.status}</td>
                      <td>{item?.generatedBy}</td>
                    </tr>
                    <Collapse in={openChatModule === item?.queryId}>
                      <tr>
                        <td colSpan={6} className="p-0">
                          <div className="hstack flex-column h-100 w-100 justify-content-between">
                            <div className="p-2 hstack bg-transparent justify-content-between">
                              <div className="text-wrap"><b>Message:</b> {item?.message}</div><br />
                              <div style={{ width: 200 }} className="d-flex gap-2 CP">
                                <Badge className="br3 text-dark" bg="success-subtle" style={{ fontSize: 12 }}>
                                  #{item?.queryId}
                                </Badge>
                                <Badge
                                  className="br3 text-dark border"
                                  bg={item?.status === "open" ? "danger-subtle" : "border-muted"}
                                  onClick={(e) => {
                                      if (!(item?.status === "open" || item?.status === "close")) {
                                        generateQueryNotificationStatusStudySubjectFormField(item?.queryId, "open")
                                      }
                                    }}
                                  style={{ fontSize: 12 }}
                                >
                                  Open
                                </Badge>
                                <Badge
                                  className="br3 text-dark border"
                                  bg={item?.status === "close" ? "success-subtle" : ""}
                                  onClick={(e) => {
                                      if (!(item?.status === "close")) {
                                        generateQueryNotificationStatusStudySubjectFormField(item?.queryId, "close")
                                      }
                                    }}
                                  style={{ fontSize: 12 }}
                                >
                                  Close
                                </Badge>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </Collapse>
                  </>
                ))}
              </tbody>
            </Table>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default FieldErrorNotification;